import moment from "moment";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const MonthCalendarHeader = ({ calendarHeaderObj: { prevDate, nextDate, handleAtualDate, viewHandler } }) => {
  const { t } = useTranslation();

  const screens = ["month", "week", "day", "list"];
  const { user } = useSelector((state) => state.userReducer);
  const { activeScreen, selectedStart, selectedEnd, selectedDateTime } = useSelector((state) => state.calendarReducer);
  const isManager = user?.role === "companyManager" || user?.role === "customerService" || user?.role === "coordinator";
  const isListCalendar = activeScreen === "list";
  const startYear = moment(selectedStart).format(` • YYYY`);
  const startMonth = t(moment(selectedStart).format("MMM").toUpperCase());
  const startWeekYear = moment(selectedStart).startOf("week").format(` • YYYY`);
  const startWeekMonth = t(moment(selectedStart).startOf("week").format("MMM").toUpperCase());
  const startWeekDay = moment(selectedStart).startOf("week").format("DD");
  const startDay = moment(selectedStart).format("DD");
  const endMonth = t(moment(selectedEnd).format("MMM").toUpperCase());
  const endWeekYear = moment(selectedStart).endOf("week").format(` • YYYY`);
  const endWeekMonth = t(moment(selectedStart).endOf("week").format("MMM").toUpperCase());
  const endWeekDay = moment(selectedStart).endOf("week").format("DD");
  const endDay = moment(selectedEnd).format("DD");
  const endYear = moment(selectedEnd).format(` • YYYY`);
  const sameYear = startYear === endYear;
  const sameWeekYear = startWeekYear === endWeekYear;
  const sameMonth = startMonth === endMonth;
  const sameWeekMonth = startWeekMonth === endWeekMonth;
  const sameDay = startDay === endDay;
  const sameDate = sameYear && sameMonth && sameDay;

  const atualDateLabel = () => {
    switch (activeScreen) {
      case "month":
        return `${t(moment(selectedStart).format("MMMM").toUpperCase())} ${moment(selectedStart).format(`• YYYY`)}`;
      case "week":
        return `${startWeekMonth} ${startWeekDay} ${sameWeekYear ? "" : startWeekYear} ${
          sameWeekMonth ? ` - ${endWeekDay}` : ` - ${endWeekMonth} ${endWeekDay}`
        } ${endYear}`;

      case "day":
        return `${startMonth} ${startDay} ${startYear}`;
      case "list":
        return `${startMonth} ${startDay} ${sameYear ? "" : startYear} ${
          sameDate ? "" : sameMonth ? ` - ${endDay}` : ` - ${endMonth} ${endDay}`
        } ${endYear} ${selectedDateTime ? `- ${selectedDateTime}` : ""}`;
      default:
        break;
    }
  };
  return (
    <div className="calendarHeader">
      <div className={`dateHandlerBox ${isListCalendar ? (isManager ? "dnone" : "") : ""}`}>
        <div className="dateHandler">
          <button className="prevDate" onClick={() => prevDate()}>
            <i className="fa fa-angle-left" />
          </button>
          <button className="nextDate" onClick={() => nextDate()}>
            <i className="fa fa-angle-right" />
          </button>
        </div>
        <button className="atualDate" onClick={() => handleAtualDate()}>
          {t("TODAY")}
        </button>
      </div>
      <p className="atualDateLabel">{atualDateLabel()}</p>
      <ul className="viewHandler">
        {screens.map((item) => (
          <li key={item} className={`${activeScreen === item ? "active" : ""}`} onClick={() => viewHandler(item)}>
            {t(item.toUpperCase())}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MonthCalendarHeader;
